var _defs, _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _rect9, _ellipse, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 164",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "forge-glow",
    cx: "50%",
    cy: "60%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffeea0",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#ff9a10",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#8a3800",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0d0806",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stone-bg",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0d1018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#050608"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chest-wood",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5a2a08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a1004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chest-lid",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3a1a04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a0c02"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 164,
    fill: "url(#stone-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 164,
    fill: "url(#forge-glow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 164 L0 100 Q10 95 20 100 L20 164Z",
    fill: "#0a0c0e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 164 L180 105 Q190 100 200 105 L200 164Z",
    fill: "#0a0c0e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 164 L0 130 Q40 120 80 125 Q100 122 120 125 Q160 120 200 130 L200 164Z",
    fill: "#080a0c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 90,
    width: 90,
    height: 50,
    rx: 4,
    fill: "url(#chest-wood)",
    stroke: "#7a3810",
    strokeWidth: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 90,
    width: 90,
    height: 8,
    rx: 2,
    fill: "#8a4010",
    opacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 95,
    width: 80,
    height: 2,
    fill: "#ff9020",
    opacity: 0.15
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 62,
    width: 90,
    height: 35,
    rx: 4,
    fill: "url(#chest-lid)",
    stroke: "#6a3008",
    strokeWidth: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 65,
    width: 84,
    height: 28,
    rx: 2,
    fill: "#ff8010",
    opacity: 0.06
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 115,
    width: 20,
    height: 12,
    rx: 2,
    fill: "#6a3010",
    stroke: "#c07020",
    strokeWidth: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 121,
    r: 3,
    fill: "#e09030",
    stroke: "#ffd060",
    strokeWidth: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 60,
    width: 16,
    height: 4,
    fill: "#c07020",
    rx: 1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 95,
    rx: 45,
    ry: 18,
    fill: "url(#forge-glow)",
    opacity: 0.7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 40,
    x2: 75,
    y2: 75,
    stroke: "#c08020",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 38,
    x2: 82,
    y2: 38,
    stroke: "#e0a030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 42,
    x2: 70,
    y2: 40,
    stroke: "#c08020",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 35,
    x2: 88,
    y2: 70,
    stroke: "#d09020",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 87,
    y1: 33,
    x2: 93,
    y2: 33,
    stroke: "#e0b030",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 32,
    x2: 100,
    y2: 65,
    stroke: "#c07010",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 36,
    x2: 104,
    y2: 30,
    stroke: "#e08020",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 30,
    x2: 104,
    y2: 36,
    stroke: "#e08020",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 35,
    x2: 112,
    y2: 70,
    stroke: "#d09020",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 107,
    y1: 33,
    x2: 113,
    y2: 33,
    stroke: "#e0b030",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 40,
    x2: 125,
    y2: 75,
    stroke: "#c08020",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 38,
    x2: 122,
    y2: 38,
    stroke: "#e0a030",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 52,
    r: 1.2,
    fill: "#ffd060",
    opacity: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 46,
    r: 0.9,
    fill: "#ffb030",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 43,
    r: 1.5,
    fill: "#fff0a0",
    opacity: 0.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 46,
    r: 0.9,
    fill: "#ffb030",
    opacity: 0.7
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 50,
    r: 1.1,
    fill: "#ffd060",
    opacity: 0.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 58,
    r: 0.6,
    fill: "#ff9020",
    opacity: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 57,
    r: 0.6,
    fill: "#ff9020",
    opacity: 0.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 48,
    r: 0.5,
    fill: "#ffc040",
    opacity: 0.6
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 50,
    r: 0.4,
    fill: "#ffd060",
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 140 Q40 130 38 120 Q36 115 40 112 Q44 115 42 122 Q45 130 40 140Z",
    fill: "#0c0e10",
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155 138 Q160 128 158 118 Q156 113 160 110 Q164 113 162 120 Q165 128 160 138Z",
    fill: "#0c0e10",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.995a8309879643c10284611dbf0f98f2.svg";
export { ForwardRef as ReactComponent };